export default "__VITE_ASSET__BJCyHvwT__"